import { registerLanguage } from './core/registry.js';
import bash from './langs/bash.js';
import c from './langs/c.js';
import clojure from './langs/clojure.js';
import cpp from './langs/cpp.js';
import csharp from './langs/csharp.js';
import css from './langs/css.js';
import curl from './langs/curl.js';
import dart from './langs/dart.js';
import diff from './langs/diff.js';
import dockerfile from './langs/dockerfile.js';
import elixir from './langs/elixir.js';
import fsharp from './langs/fsharp.js';
import go from './langs/go.js';
import graphql from './langs/graphql.js';
import haskell from './langs/haskell.js';
import html from './langs/html.js';
import http from './langs/http.js';
import ini from './langs/ini.js';
import java from './langs/java.js';
import javascript from './langs/javascript.js';
import json from './langs/json.js';
import julia from './langs/julia.js';
import kotlin from './langs/kotlin.js';
import lua from './langs/lua.js';
import makefile from './langs/makefile.js';
import markdown from './langs/markdown.js';
import matlab from './langs/matlab.js';
import mojo from './langs/mojo.js';
import nginx from './langs/nginx.js';
import objectivec from './langs/objectivec.js';
import ocaml from './langs/ocaml.js';
import perl from './langs/perl.js';
import php from './langs/php.js';
import powershell from './langs/powershell.js';
import python from './langs/python.js';
import r from './langs/r.js';
import ruby from './langs/ruby.js';
import rust from './langs/rust.js';
import scala from './langs/scala.js';
import sql from './langs/sql.js';
import swift from './langs/swift.js';
import yaml from './langs/yaml.js';
/**
 * Every bundled language, registered on import.
 *
 * Meant for build-time rendering — static site generators, docs pipelines,
 * anything where bundle size is not a constraint. In a browser bundle prefer
 * `@scalar/highlight/lazy`, or import the two or three languages you actually use.
 */
export const languages = [
    bash,
    c,
    clojure,
    cpp,
    csharp,
    css,
    curl,
    dart,
    diff,
    dockerfile,
    elixir,
    fsharp,
    go,
    graphql,
    haskell,
    html,
    http,
    ini,
    java,
    javascript,
    json,
    julia,
    kotlin,
    lua,
    makefile,
    markdown,
    matlab,
    mojo,
    nginx,
    objectivec,
    ocaml,
    perl,
    php,
    powershell,
    python,
    r,
    ruby,
    rust,
    scala,
    sql,
    swift,
    yaml,
];
registerLanguage(...languages);
/**
 * The root entry's surface, re-exported by name.
 *
 * `import { highlight } from '@scalar/highlight/all'` has to work without a
 * second import, so everything `.` exports is listed here. Spelled out rather
 * than `export *` so the entry's surface is greppable and Biome's barrel-file
 * rules stay satisfied.
 */
export { compile } from './core/compile.js';
export { getLanguage, isRegistered, listLanguages, registerLanguage, resolveGrammar, } from './core/registry.js';
export { DEFAULT_PREFIX, escapeAttribute, escapeHtml } from './core/render.js';
export { SCOPES, SCOPE_NAMES, scopeChain, scopeClass } from './core/scopes.js';
export { tokenize as tokenizeStream } from './core/tokenize.js';
export { highlight, highlightBlock, tokenize } from './index.js';
